import { useMemo } from 'react'
import type { SupplierReconciliationMetadataResponse, ReasonCode } from '../../../../api/useMetadata/types'

export interface ReasonCodeOption {
  value: string
  label: string
  key: string
}

/**
 * Hook to provide filtered reason codes for different processes
 */
export function useReasonCodes(metadata?: SupplierReconciliationMetadataResponse) {
  const allReasonCodes = metadata?.reason_codes || []

  // Filter approval reason codes
  const approvalReasonCodes = useMemo(() => {
    return allReasonCodes.filter((reasonCode: ReasonCode) =>
      reasonCode.processes.includes('supplier_reconciliation_approval')
    )
  }, [allReasonCodes])

  // Filter hold reason codes
  const holdReasonCodes = useMemo(() => {
    return allReasonCodes.filter((reasonCode: ReasonCode) =>
      reasonCode.processes.includes('supplier_reconciliation_hold')
    )
  }, [allReasonCodes])

  // Transform approval reason codes into dropdown options
  const approvalReasonCodeOptions = useMemo(() => {
    return approvalReasonCodes.map((reasonCode: ReasonCode) => ({
      value: reasonCode.reason_id,
      label: reasonCode.reason,
      key: reasonCode.id,
    }))
  }, [approvalReasonCodes])

  // Transform hold reason codes into dropdown options
  const holdReasonCodeOptions = useMemo(() => {
    return holdReasonCodes.map((reasonCode: ReasonCode) => ({
      value: reasonCode.reason_id,
      label: reasonCode.reason,
      key: reasonCode.id,
    }))
  }, [holdReasonCodes])

  return {
    // Raw reason codes
    approvalReasonCodes,
    holdReasonCodes,
    allReasonCodes,

    // Dropdown options
    approvalReasonCodeOptions,
    holdReasonCodeOptions,
  }
}
